/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Login from '../../pages/auth/Login';
import { ConsultaHelper, NumberHelper } from '../../../../shared/helpers';
import {
    changeAutoridades,
    changeSubmenuSelected
} from "../../../../store/ducks/dadosAcervo";

import VisualizadorPdfV2 from '../Home/VisualizadorPdfV2';
import { CreativeCommonsHelper } from '../../../../shared/helpers/CreativeCommonsHelper';
import MediaView from '../Home/MediaView';
import Button from '../../../consulta-acessibilidade/Button';

const OpenModalRender = ({ t, descricao, flag }) => {
    const title = flag === 'AC' ? t('CliqueAcessarMaterialAcessibilidade') : t('CliqueAcessarMaterialAcessoRestrito');
    return (
        <span className="link hover1 f500 azul" title={title}>
            <FontAwesomeIcon
                icon={flag === 'AC' ? 'universal-access' : 'lock'}
                className={`s13 r5 ${flag === 'AC' ? '' : 'preto70'}`}
            />
            {descricao}
        </span>
    );
};

const AltRenderLoginAcessibilidade = ({ t, auth, data, instituicaoRx, codAcervo, descricao }) => {
    if(auth){
        if(data.is_pdf){
            const {usa_visualizador_php} = instituicaoRx;
            if((usa_visualizador_php && usa_visualizador_php === '1') || data?.link_data?.download_pdf === 'N'){
                return (
                    <span className="f500">
                        <VisualizadorPdfV2
                            codAcervo={codAcervo}
                            seqParagrafo={data.seq_paragrafo}
                            isRestricted
                        />
                        {descricao}
                    </span>
                )
            }
        }else if(data.link_data.is_media){
            return (
                <span className="f500">
                    <MediaView
                        title={descricao}
                        uri={data.link_acesso}
                        format={data.link_data.media_format}
                    />
                {descricao}
                </span>)
        }

        return (
            <span
                className="link hover1 f500 azul"
                title={t('CliqueAcessarMaterialAcessibilidade')}
                onClick={() =>
                    ConsultaHelper.acessarLinkAcessoRestrito(
                        codAcervo,
                        data.seq_paragrafo,
                    )
                }
            >
                <FontAwesomeIcon
                    icon="universal-access"
                    className="s13 r5"
                />
                {descricao}
            </span>
        )
    }
    return null;
}

const AltRenderLoginAcessoRestrito = ({ t, auth, data, instituicaoRx, codAcervo, descricao, isOpenMediaViewOnLogin, setIsOpenMediaViewOnLogin }) => {
    const verifyOpen = (seqParagrafo) => {
        if(isOpenMediaViewOnLogin){
            const {seq_paragrafo} = isOpenMediaViewOnLogin;
            if(seqParagrafo === seq_paragrafo){
                return true;
            }
        }
        return false;
    }

    if(auth){
        if(data.is_pdf){
            const {usa_visualizador_php} = instituicaoRx;
            if((usa_visualizador_php && usa_visualizador_php === '1') || data?.link_data?.download_pdf ===  'N'){
                return (
                    <span className="f500">
                            <VisualizadorPdfV2
                                codAcervo={codAcervo}
                                seqParagrafo={data.seq_paragrafo}
                                isRestricted
                            />
                            {descricao}
                    </span>)
            }
        } else if(data.link_data.is_media){
            return (
                <span className="f500">
                    <MediaView
                        open={verifyOpen(data.seq_paragrafo)}
                        codAcervo={codAcervo}
                        isRestricted
                        seqParagrafo={data.seq_paragrafo}
                        title={descricao}
                        uri={data.link_acesso}
                        format={data.link_data.media_format}
                        onClosed={() => setIsOpenMediaViewOnLogin(undefined)}
                    />
                    {descricao}
                </span>
            )
        }

        return (
            <span
                className="link hover1 f500 azul"
                title={t('CliqueAcessarMaterialAcessoRestrito')}
                onClick={() =>
                    ConsultaHelper.acessarLinkAcessoRestrito(
                        codAcervo,
                        data.seq_paragrafo,
                    )
                }
            >
                <FontAwesomeIcon
                    icon="lock-open"
                    className="s13 preto70 r5"
                />
                {descricao}
            </span>
        )
    }
    return null;
}

const CampoDadosAcervo = ({ codAcervo, campo, viewModeBiblioteca}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const instituicaoRx = useSelector(state => state.instituicao.data);
    const guiasPesquisaRx = useSelector(state => state.pageConfig.guiasPesquisa);
    const opcoesResultadoRx = useSelector(state => state.pesquisa.opcoesResultado);
    const [isOpenViewPdfRestrictedOnce, setIsOpenViewPdfRestrictedOnce] = useState(null);
    const [isOpenMediaViewOnLogin, setIsOpenMediaViewOnLogin] = useState(undefined);
    const { qtde_min_seq_paragrafo, url_php } = instituicaoRx;
    const [isOpenCollapse, setIsOpenCollapse] = useState(false);

    const handleClickDetails = (arrCodAutoridade) => {
        dispatch(changeAutoridades([...new Set(arrCodAutoridade)]))
        dispatch(changeSubmenuSelected({
            parent: '0',
            submenu: 'detalhes',
            name: t('Detalhes')
        }))
    }

    /**
     * Regra para a visualização da lupa, leva em consideração descrições na mesma linha
     * @param totalDescricao
     * @param indiceAtual
     * @returns {boolean}
     */
    const regraLupa = (data, indiceAtual) => {
        if(data.descricao.length === 1){
            return true;
        }
        /**
         * Verifica se existe outra descrição que possui autoridade_completa (Lupa)
         */
         const existsOther = data.descricao.some((desc, index) => {
            if(index !== indiceAtual){
                if(data?.gerar_pesquisa){
                    const flagPesquisa = data?.gerar_pesquisa[index]
                    if(flagPesquisa && flagPesquisa.endsWith('C')){
                        return true;
                    }
                }else if(data?.contem_autoridade_completa){
                    if(data.contem_autoridade_completa[index] === true){
                        return true;
                    }
                }
            }
            return false;
        })
        return ( (existsOther && data.descricao.length ===  (indiceAtual +1))  || !existsOther );
    }

    const getUrl = (url) => {
        if(url === null || url.trim() === ''){
            return '#';
        }
        const pattern = /^http|https|ftp/
        if(!pattern.test(url.trim())){
            return `http://${url.trim()}`;
        }
        return url;
    }

    const getUrlGeraPesquisa = (codAutoridade, descricao, paramFor) => {
        //Se possui cod_autoridade, os links tem que ser pra busca da autoridade específica
        if (codAutoridade) {
            return `/autoridades?q=${codAutoridade}&for=AUTORIDADE_TODOS&aut_id=${codAutoridade}`;
        }
        const usaParametrosPaginada = guiasPesquisaRx.find(guia => guia.codigo === 'pesquisa_geral')?.usa_consulta_paginada || false;
        let baseResearchUrl = `/pesquisa_geral?q=${descricao.trim()}&for=${paramFor}&research=true`;
        const orderBy = opcoesResultadoRx.ordenacaoCombo || 'obra'
        if (usaParametrosPaginada) {
            baseResearchUrl += `&page=1&perPage=20&orderBy=${orderBy}&direction=${orderBy === 'ano_publicacao' ? 'D' : 'C'}`;
        }
        return baseResearchUrl;
    }

    const renderVinculoAcessibilidade = (data, contSeqSecao, descricao) => {
        return (
            <div
                key={`link__${data.paragrafo}${contSeqSecao}`}
                className="t5 b5"
            >
                <Login
                    modal
                    openModalRender={() => OpenModalRender({t, descricao, flag: data.link_acesso})}
                    altRender={auth => <AltRenderLoginAcessibilidade t={t} auth={auth} data={data} instituicaoRx={instituicaoRx} codAcervo={codAcervo} descricao={descricao} />}
                    loginCallback={() => {
                        if(data.is_pdf){
                            const {usa_visualizador_php} = instituicaoRx
                            if((usa_visualizador_php && usa_visualizador_php === '1') || data?.download_pdf === 'N'){
                                setIsOpenViewPdfRestrictedOnce({ seqParagrafo: data.seq_paragrafo})
                                return;
                            }
                        }else if(data.link_data.is_media){
                            setIsOpenMediaViewOnLogin({
                                seq_paragrafo: data.seq_paragrafo
                            })
                            return;
                        }
                        ConsultaHelper.acessarLinkAcessoRestrito(codAcervo,data.seq_paragrafo)
                    }}
                />
                {
                    isOpenViewPdfRestrictedOnce !== null && isOpenViewPdfRestrictedOnce?.seqParagrafo === data.seq_paragrafo  ? (
                        <VisualizadorPdfV2
                            codAcervo={codAcervo}
                            seqParagrafo={data.seq_paragrafo}
                            isRestrictedOnce
                            isOpen
                            setIsOpenViewPdfRestrictedOnce={setIsOpenViewPdfRestrictedOnce}
                        />
                    ) : ''
                }
            </div>
        );
    }

    const renderVinculoAcessoRestrito = (data, contSeqSecao, descricao) => {
        return (
            <div
                key={`link__${data.paragrafo}${contSeqSecao}`}
                className="t5 b5"
            >
                <Login
                    modal
                    msgErroCustom={data.msg_err_login}
                    openModalRender={() => OpenModalRender({t, descricao, flag: data.link_acesso})}
                    altRender={auth => <AltRenderLoginAcessoRestrito t={t} auth={auth} data={data} instituicaoRx={instituicaoRx} codAcervo={codAcervo} descricao={descricao} isOpenMediaViewOnLogin={isOpenMediaViewOnLogin} setIsOpenMediaViewOnLogin={setIsOpenMediaViewOnLogin} />}
                    loginCallback={() => {
                        if(data.is_pdf) {
                            const {usa_visualizador_php} = instituicaoRx
                            if((usa_visualizador_php && usa_visualizador_php === '1') || data?.link_data?.download_pdf === 'N') {
                                setIsOpenViewPdfRestrictedOnce({ seqParagrafo: data.seq_paragrafo})
                                return;
                            }
                        }else if(data.link_data.is_media){
                            setIsOpenMediaViewOnLogin({
                                seq_paragrafo: data.seq_paragrafo
                            })
                            return;
                        }
                        ConsultaHelper.acessarLinkAcessoRestrito(codAcervo,data.seq_paragrafo)
                    }}
                />
                {
                    isOpenViewPdfRestrictedOnce !== null && isOpenViewPdfRestrictedOnce?.seqParagrafo === data.seq_paragrafo  ? (
                        <VisualizadorPdfV2
                            codAcervo={codAcervo}
                            seqParagrafo={data.seq_paragrafo}
                            isRestrictedOnce
                            isOpen
                            setIsOpenViewPdfRestrictedOnce={setIsOpenViewPdfRestrictedOnce}
                        />
                    ) : ''
                }
            </div>
        );
    }

    const renderLinkVinculo = (data, descricao, hrefAncora) => {
        if (data.is_pdf && ((instituicaoRx.usa_visualizador_php && instituicaoRx.usa_visualizador_php === '1') || data?.link_data?.download_pdf === 'N')) {
            return (
                <span className="f500">
                    <VisualizadorPdfV2
                        descricao={descricao}
                        urlPdf={hrefAncora} />
                        {descricao}
                    </span>
            )
        }
        if (data.link_data.is_media) {
            return (
                <span className="f500">
                    <MediaView title={descricao}
                        uri={data.link_acesso}
                        format={data.link_data.media_format}
                    />
                    {descricao}
                </span>
            )
        }

        return (
            <span
                className="link hover1 azul f500"
                title={t('CliqueAcessarMaterialOnline')}
                onClick={() =>
                    ConsultaHelper.acessarVinculo(
                    codAcervo,
                    data.seq_paragrafo,
                    getUrl(hrefAncora),
                )
            }
        >
            <FontAwesomeIcon
                icon="link"
                className="s13 preto70 r5"
            />
            {descricao}
            </span>
        )
    }

    const renderCampoVinculo = (data, descricao, contSeqSecao) => {
        const hrefAncora =
            data.link_acesso === 'VB'
                ? `${url_php.replace(/\/$/, '')}/vinculo/publico/${codAcervo}/seq/${data.seq_paragrafo}/${descricao}`
                : data.link_acesso;

        if (data.link_acesso === 'AC') {
            return renderVinculoAcessibilidade(data, contSeqSecao, descricao);
        }   
        if (data.link_acesso === 'AR') {
            return renderVinculoAcessoRestrito(data, contSeqSecao, descricao);
        }
         if (data.link_data.is_media){
            return (
                <div key={`link__media_${data.paragrafo}${contSeqSecao}`} className="t5 b5">
                    <span className="f500">
                        <MediaView
                            title={descricao}
                            uri={data.link_acesso}
                            format={data.link_data.media_format}
                        />
                            {descricao}
                    </span>
                </div>
            );
        }
        
        return (
            <div
                key={`link__${data.paragrafo}${contSeqSecao}`}
                className="t5 b5"
            >
            {renderLinkVinculo(data, descricao, hrefAncora)}
            </div>
        );
    }

    const gerarConteudoCampo = data => {
        const resultNewMethod = renderFieldContentWithNewRules(data)
        if(resultNewMethod){
            return resultNewMethod;
        }

        const content = [];
        // ? Itera sobre os arrays de detalhes, usa o tamanho do array da descricao como base
        for (
            let contSeqSecao = 0;
            contSeqSecao < data.descricao.length;
            // eslint-disable-next-line no-plusplus
            contSeqSecao++
        ) {
            const descricao = data.descricao[contSeqSecao];
            const flagPesquisa = data.gerar_pesquisa ? data.gerar_pesquisa[contSeqSecao] : null;
            let pontuacao = data.pontuacao[contSeqSecao];
            pontuacao = pontuacao == null ? '' : pontuacao;
            const {cod_acervo_link, formatar_link} = data.extra[contSeqSecao];
            let codAutoridade = null;
            if(data.cod_autoridade && data.cod_autoridade?.length > 0){
                codAutoridade = data.cod_autoridade[contSeqSecao];
            }

            // Informacoes textuais sem links
            if (!data.gerar_pesquisa || flagPesquisa === "N") {
                //Alterações aqui, avaliar replicação no CampoDadosArquivo.jsx e VinculosPaginaDireita.jsx
                if (data.vinculo) {
                    content.push(renderCampoVinculo(data, descricao, contSeqSecao));
                } else { // END vinculos
                    // ? Conteúdo padrão
                    /**
                     * Regra para a criação de link caso o campo formatar_link não seja nulo
                     */
                    if(data.extra[contSeqSecao].formatar_link === '1'){

                        if (NumberHelper.parseInt(data.extra[contSeqSecao].paragrafo) === 985){

                            const tituloLink = data.descricao985 ? data.descricao985 : descricao;
                            const linkRedirecionamento = data.link_acesso ? data.link_acesso : descricao;

                            if(data.link_acesso){
                                content.push(<Link
                                    className="link hover1 f500"
                                    title={t('Acessar')}
                                    to={{pathname: getUrl(linkRedirecionamento)}}
                                    target='_blank'
                                    key={`link_gerar_link__${data.paragrafo}${contSeqSecao}`}
                                >
                                    <FontAwesomeIcon icon="link" className="s13 preto70 r5"/>

                                    {`${tituloLink.replaceAll("<br />\n", "\n")
                                        .replaceAll("<br />", "\n")
                                        .replaceAll("<br/>", "\n")
                                        .replaceAll("<br>", "\n")}${pontuacao}`}
                                </Link>);
                            }else{
                                content.push(
                                    <span
                                        key={`info__${data.paragrafo}${contSeqSecao}`}
                                        className={`f500 ${contSeqSecao !== 0 && 'l5'}`}
                                        style={{whiteSpace: "pre-line"}}
                                        dangerouslySetInnerHTML={{__html: `${descricao
                                                .replaceAll("<br />\n", "\n")
                                                .replaceAll("<br />", "\n")
                                                .replaceAll("<br/>", "\n")
                                                .replaceAll("<br>", "\n")}${pontuacao}`}}
                                    />
                                );
                            }


                        }else{
                            content.push(<Link
                                className="link hover1 f500"
                                title={t('Acessar')}
                                to={{pathname: getUrl(descricao)}}
                                target='_blank'
                                key={`link_gerar_link__${data.paragrafo}${contSeqSecao}`}
                            >
                                <FontAwesomeIcon icon="link" className="s13 preto70 r5"/>

                                {`${descricao
                                    .replaceAll("<br />\n", "\n")
                                    .replaceAll("<br />", "\n")
                                    .replaceAll("<br/>", "\n")
                                    .replaceAll("<br>", "\n")}${pontuacao}`}
                            </Link>,)
                        }

                    }else if(data?.isSecaoW && data.isSecaoW[contSeqSecao] === true){
                        content.push(<Link
                            className="link hover1 f500"
                            title="Consultar acervo"
                            to={data.link_acervo}
                            key={`link_secao_w__${data.paragrafo}${contSeqSecao}`}
                        >
                            {`${descricao}${pontuacao}`}
                        </Link>);
                    }
                    // 985 sem $u
                    else if (NumberHelper.parseInt(data.extra[contSeqSecao].paragrafo) === 985 && !data.link_acesso){
                            content.push(
                                <span
                                    key={`info__${data.paragrafo}${contSeqSecao}`}
                                    className={`f500 ${contSeqSecao !== 0 && 'l5'}`}
                                    style={{whiteSpace: "pre-line"}}
                                    dangerouslySetInnerHTML={{__html: `${descricao
                                            .replaceAll("<br />\n", "\n")
                                            .replaceAll("<br />", "\n")
                                            .replaceAll("<br/>", "\n")
                                            .replaceAll("<br>", "\n")}${pontuacao}`}}
                                />,
                            );
                    }else if(codAutoridade){
                        content.push(<Link
                            className="link hover1 f500"
                            title={t('Autoridade')}
                            to={`/autoridade/${codAutoridade}`}
                        >
                            {`${descricao}${pontuacao}`}
                        </Link>)
                    }
                    else if (NumberHelper.parseInt(data.extra[contSeqSecao].paragrafo) !== 985){
                        if(formatar_link === "1" && cod_acervo_link){
                            content.push(
                                <span
                                    key={`info__${data.paragrafo}${contSeqSecao}`}
                                    className={`f500 ${contSeqSecao !== 0 && 'l5'}`}
                                    style={{whiteSpace: "pre-line"}}
                                >
                                    <Link to={`/acervo/${cod_acervo_link}`}>
                                        {`${descricao
                                            .replaceAll("<br />\n", "\n")
                                            .replaceAll("<br />", "\n")
                                            .replaceAll("<br/>", "\n")
                                            .replaceAll("<br>", "\n")}${pontuacao}`}
                                    </Link>
                            </span>,
                            );
                        }else{
                            content.push((
                                <span
                                    key={`info__${data.paragrafo}${contSeqSecao}`}
                                    className={`f500 ${contSeqSecao !== 0 && 'l5'}`}
                                    style={{whiteSpace: "pre-line"}}
                                    dangerouslySetInnerHTML={{__html: `${descricao
                                            .replaceAll("<br />\n", "\n")
                                            .replaceAll("<br />", "\n")
                                            .replaceAll("<br/>", "\n")
                                            .replaceAll("<br>", "\n")}${pontuacao}`}}
                                />
                            ))
                        }
                    }

                    if(data?.contem_autoridade_completa && data.contem_autoridade_completa[contSeqSecao] === true){
                        if(regraLupa(data, contSeqSecao)){
                            content.push(
                                <a className="l5"
                                      title={t("Detalhes")}
                                      onClick={() => handleClickDetails(data.cod_autoridade, contSeqSecao)}
                                      key={`link_details__${data.paragrafo}${contSeqSecao}`} >
                                    <FontAwesomeIcon icon="search" className="azul hover1" />
                                </a>
                            );
                        }
                    }
                }
            } else {
                // Se gera pesquisa:
                
                let codAutoridade = null
                if(data.cod_autoridade?.length && data.cod_autoridade.filter(x => x !== null)?.length > 0) {
                    codAutoridade = data.cod_autoridade[contSeqSecao];
                }

                if(flagPesquisa.startsWith('N')  && NumberHelper.parseInt(data.paragrafo) === 710){
                    if (contSeqSecao === 0) {
                       // let termo = data.descricao.join('%@%');
                        const descricaoformatadaTratamento = data.descricao.filter((desc, index) => data.cod_autoridade[index] !== null);
                        const descricaoformatada710 = descricaoformatadaTratamento.join('.');
                        const query = getUrlGeraPesquisa(codAutoridade, descricaoformatada710.trim(), 'AUTOR');
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title={t('ConsultarPorAutor')}
                                to={query}
                                key={`link_subject__${data.paragrafo}${contSeqSecao}`}
                            >
                                {descricaoformatada710}
                            </Link>,
                        );
                    }
                }

                //secao 1 do paragrafo 100 -> link externo.
                if (flagPesquisa === 'LE') {
                    content.push(
                        <a className="link hover1 f500"
                            title={t("ConsultarPorAutor")}
                            href={descricao}
                            key={`link_details__${data.paragrafo}${contSeqSecao}`} >
                            {descricao}
                        </a>
                    );
                }

                if (flagPesquisa.startsWith('A') ||
                   flagPesquisa.startsWith('N') &&
                   NumberHelper.parseInt(data.paragrafo) !== 710
                   ) {
                    // ? Pesquisa nova por código de autoridade
                    if(viewModeBiblioteca){
                        if(codAutoridade){
                            content.push(
                                <Link
                                    className="link hover1 f500"
                                    title={t('Autoridade')}
                                    to={`/autoridade/${codAutoridade}`}
                                    key={`link_author_${data.paragrafo}${contSeqSecao}__${data.cod_autoridade[contSeqSecao]}`}
                                >
                                    {`${descricao}${pontuacao}`}
                                </Link>,
                            );
                        }
                    }else{
                        const query = getUrlGeraPesquisa(codAutoridade, descricao, 'AUTOR');
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title={t('ConsultarPorAutor')}
                                to={query}
                                key={`link_author__${data.paragrafo}${contSeqSecao}`}
                            >
                                {`${descricao}${pontuacao}`}
                            </Link>,
                        );
                    }
                } else if (flagPesquisa.startsWith('T')) {
                    // ? Pesquisa por termo do assunto (gera um link unico por seqParagrafo)
                        const query = getUrlGeraPesquisa(codAutoridade, descricao, 'ASSUNTO');

                        if(viewModeBiblioteca){
                            if(codAutoridade){
                                data.cod_autoridade.forEach((cod_autoridade, i) => {
                                    if(i > 0){
                                        content.push(data.pontuacao[i])
                                    }
                                    content.push(
                                        <Link
                                            className="link hover1 f500"
                                            title={t('Autoridade')}
                                            to={`/autoridade/${codAutoridade}`}
                                            key={`link_subject__${data.paragrafo}${contSeqSecao}${cod_autoridade}`}                                    >
                                            {data.descricao[i]}
                                        </Link>,
                                    );
                                })
                            }
                        }else{
                            content.push(
                                <Link
                                    className="link hover1 f500"
                                    title={t('ConsultarPorAssunto')}
                                    to={query}
                                    key={`link_subject__${data.paragrafo}${contSeqSecao}`}
                                >
                                    {`${descricao}${pontuacao}`}
                                </Link>,
                            );
                    }
                } else if (flagPesquisa.startsWith('W')) {
                    // ? Pesquisa por título
                    const query = getUrlGeraPesquisa(codAutoridade, descricao, 'TITULO');

                    if(data?.isSecaoW && data.isSecaoW[contSeqSecao] === true){
                        content.push(<Link
                            className="link hover1 f500"
                            title="Consultar acervo"
                            to={data.link_acervo}
                            key={`link_secao_w__${data.paragrafo}${contSeqSecao}`}
                        >
                            {`${descricao}${pontuacao}`}
                        </Link>);
                    }else{
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title={t('ConsultarPorAssunto')}
                                to={query}
                                key={`link_titulo__${data.paragrafo}${contSeqSecao}`}
                            >
                                {`${descricao}${pontuacao}`}
                            </Link>,
                        );
                    }

                }

                 if (flagPesquisa.endsWith("C")) {
                     if(regraLupa(data, contSeqSecao)){
                         content.push(
                             <a className="l5"
                                   title={t("Detalhes")}
                                   onClick={() => {
                                       handleClickDetails(data.cod_autoridade)
                                   }}
                                   key={`link_details__${data.paragrafo}${contSeqSecao}`} >
                                 <FontAwesomeIcon icon="search" className="azul hover1" />
                             </a>
                         );
                     }
                }
            }
        }
        return (
            <div
                key={`seqPar${data.seq_paragrafo}`}
                style={{ display: data.vinculo ? 'inline' : 'inline-block' }}
                className="s14 text-justify"
            >
                {content}
            </div>
        );
    };


    const renderFieldContentWithNewRules = (data) => {
        const renderFieldCreativeCommons = (data) => {
            const secaoA = data.extra.find(x => x.secao === 'a');
            const secaoB = data.extra.find(x => x.secao === 'b');

            const { descricao: author } = secaoA;
            const { descricao: licenseType } = secaoB;

            return <div style={{ display: 'inline-block' }} className="s14 text-justify">
                {CreativeCommonsHelper().getHtml(licenseType, author)}
            </div>
        }

        //!!Regra de renderização especifica para paragrafo 773!!
        const renderField773 = (data) => {
            const wSectionIndex = data?._secao.findIndex(x => x.trim().toLowerCase() === 'w')
            const tSectionIndex = data?._secao.findIndex(x => x.trim().toLowerCase() === 't')

            const linkByCollectionCode =  wSectionIndex > -1;
            const linkAcervo = linkByCollectionCode ? data?.link_acervo : undefined;
            const codAutoridade = !linkByCollectionCode ? data?.cod_autoridade[tSectionIndex] : undefined;

            const linkTo = linkByCollectionCode ? linkAcervo : `/autoridade/${codAutoridade}`
            const linkTooltip = linkByCollectionCode ? t('Acervo') : t('Autoridade')

            return (
                <div
                    key={data.seq_paragrafo}
                    style={{ display: data.vinculo ? 'inline' : 'inline-block' }}
                    className="s14 text-justify"
                >
                    <Link className="link hover1 f500"
                        title={linkTooltip}
                        to={linkTo}
                        key="link_773"
                    >
                        {
                            data.descricao.map((description, index) => {
                                const punctuation = data?.pontuacao[index];
                                return `${description}${punctuation}`
                            })
                        }
                    </Link>
                </div>
            )
        }
        /**
         * campo creative commons
         */
        if(data?.isCreativeCommons) {
            return renderFieldCreativeCommons(data)
        }
        //Regras por paragrafo
        switch (NumberHelper.parseInt(data.paragrafo)){
            case 773:
                return renderField773(data);
            default:
                return undefined;
        }
    }

    /**
     * Montagem dos campos diferente para acervo de biblioteca: /biblioteca/:codAcervo
     */
    if(viewModeBiblioteca){
        return (
            <div
                key={`field__${campo.ordem}`}
                className="flex-column"
                style={{ gap: '16px' }}
            >
            <span className="font-weight-bold s14 mb-1 preto70">
                {campo.texto}
            </span>
                <div className="d-flex flex-column px-1">
                    {campo.detalhes.map((detalhe, index) => (
                        <div className="preto50" key={index}>
                            {gerarConteudoCampo(detalhe)}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    const renderFieldContent = () => {
        if(!campo?.detalhes?.length) return '';

        const { detalhes } = campo;

        const handleToggleCollapse = () => {
            setIsOpenCollapse(!isOpenCollapse)
        }

        if(detalhes.length > 1){
            if(qtde_min_seq_paragrafo){
                const visibleFields = detalhes.slice(0, qtde_min_seq_paragrafo).map((fv, index) => (
                    <div key={index} style={{ display: 'block'}}>
                        {gerarConteudoCampo(fv)}
                    </div>
                ));

                const fieldsToSeeMore = detalhes.slice(qtde_min_seq_paragrafo, ).map((ftsm , index) => (
                    <div key={index} style={{ display: 'block' }}>
                        {gerarConteudoCampo(ftsm)}
                    </div>
                ))

                return (
                   <>
                       {visibleFields}
                       {
                           fieldsToSeeMore && fieldsToSeeMore?.length > 0 ? (
                               <>
                                   <Collapse
                                       className=''
                                       in={isOpenCollapse}>
                                       <div>
                                           {fieldsToSeeMore}
                                       </div>
                                   </Collapse>
                                   <Button
                                       onClick={handleToggleCollapse}
                                       title={isOpenCollapse ? t('VerMenos') : t('VerMais')}
                                       icon={isOpenCollapse ? faAngleUp : faAngleDown}
                                       variant='segundo ml-0 mt-1'
                                   />
                               </>
                           ) : ''
                       }
                   </>
                )
            }

            return detalhes.map((d, index) => (
                <div key={index} style={{ display: 'block' }}>
                    {gerarConteudoCampo(d)}
                </div>
            ))
        }

        return (
            <div style={{ display: 'block' }}>
                {gerarConteudoCampo(detalhes[0])}
            </div>
        )
    }

    return (
        <Row className="b-w1 b-cinza2 b-solid-bottom pad5 b5 corAlto1">
            <Col xs="12" md="3">
                <span className="f400 preto70 s14">{campo.texto}: </span>
            </Col>
            <Col xs="12" md="9">
                {renderFieldContent()}
            </Col>
        </Row>
    );
};

CampoDadosAcervo.propTypes = {
    campo: PropTypes.object.isRequired,
    viewModeBiblioteca: PropTypes.bool.isRequired,
};

export default CampoDadosAcervo;
